'use client';

import withAuth from '@/HOCs/withAuth';
import { takeRedirectRouteByRole } from '@/utils/roles';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { getDefaultAccess } from '../../utils/defaultAccess';
import { EpLoading } from '../../components/EpLoading';

function HomePageContent() {
    const router = useRouter();
    const defaultAccess = typeof window !== 'undefined' ? getDefaultAccess() : null;

    useEffect(() => {
        if (defaultAccess) {
            router.push(takeRedirectRouteByRole(defaultAccess?.roleId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultAccess, router]);

    return <EpLoading loadingId={'loading--page'} isVisible />;
}

export default withAuth(HomePageContent);